import * as _ from "lodash-es";

const environment = BACKEND.env;

export default function (config) {
    if (["local", "master"].includes(environment) && !_.isEmpty(_.get(config, "flags.handtalk_sitekey")) && !_.isEmpty(BACKEND.nonce) && !window.ht) {
        var htCall = document.createElement("script");
        htCall.src = "https://plugin.handtalk.me/web/latest/handtalk.min.js";
        htCall.async = true;
        htCall.setAttribute("nonce", BACKEND.nonce);
        htCall.onload = function () {
            window.ht = new window.HT({
                token: _.get(config, "flags.handtalk_sitekey")
            });
        };
        (document.body || document.head).appendChild(htCall);
    }
}
